import { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'src/utils/store'
import { actions } from '../../ShedManagementState'
import { Product } from '../../ShedManagementTypes'
import TableMui from 'src/components/TableMui'

const ProductsTable = () => {
  const { selectedProducts, products } = useSelector((state) => state.shedManagement)
  const dispatch = useDispatch()

  const rows = useMemo(() =>
    products.map(({
      idModel: id, productCode, productDescription,
    }) => ({
      id, productCode, productDescription,
    })), [products])

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = rows.map((row) => {
        const currentProduct = products.find((product) => product.idModel === row.id)
        return {
          idModel: row.id,
          productCode: currentProduct?.productCode || '',
          productDescription: currentProduct?.productDescription || '',
          idAttributeType: currentProduct?.idAttributeType || null,
          idAttributeFunction: currentProduct?.idAttributeFunction || null,
          idAttributeStorage: currentProduct?.idAttributeStorage || null,
          allowHighStorage: currentProduct?.allowHighStorage || false,
          fractioningTag: currentProduct?.fractioningTag || false,
          dueDateType: currentProduct?.dueDateType || '',
        }
      })
      dispatch(actions.setSelectedProducts({ selectedProducts: newSelected }))
      return
    }
    dispatch(actions.setSelectedProducts({ selectedProducts: [] }))
  }

  const handleClick = (id: number) => {
    const selectedIndex = selectedProducts.findIndex((product) => product.idModel === id)

    if (selectedIndex === -1) {
      const productFromProducts = products.find((product) => product.idModel === id)

      if (productFromProducts) {
        const productToAdd: Product = {
          idModel: id,
          productCode: productFromProducts.productCode,
          productDescription: productFromProducts.productDescription,
          idAttributeType: productFromProducts.idAttributeType,
          idAttributeFunction: productFromProducts.idAttributeFunction,
          idAttributeStorage: productFromProducts.idAttributeStorage,
          allowHighStorage: productFromProducts.allowHighStorage,
          fractioningTag: productFromProducts.fractioningTag,
          dueDateType: productFromProducts.dueDateType,
        }
        dispatch(actions.setSelectedProducts({ selectedProducts: [...selectedProducts, productToAdd] }))
      }
    } else {
      const updatedSelectedProducts = selectedProducts.filter((product) => product.idModel !== id)
      dispatch(actions.setSelectedProducts({ selectedProducts: updatedSelectedProducts }))
    }
  }

  return (
    <TableMui
      columns={[
        { id: 'productCode', label: 'Código do produto', minWidth: '188px' },
        { id: 'productDescription', label: 'Descrição do produto' },
      ]}
      emptyLabel='Utilize o filtro para buscar produtos'
      rows={rows}
      rowCount={rows.length}
      selectedCount={selectedProducts.length}
      enablePagination
      rowsPerPageLimit={5}
      selected={selectedProducts.map((item) => item.idModel)}
      onSelectAllClick={handleSelectAllClick}
      onRowClick={handleClick}
      width='40%'
      hasCheckbox
      hasSorting
      testId='products-table-test'
    />
  )
}

export default ProductsTable
